export const singleCategoryAccessoryEpicFilterOptions = {
  epicCategories: "omit",
  epicMaternity: "omit",
  epicEmbellishments: "omit",
  epicSeasonality: "omit",
  epicPrint: "omit",
  epicSleeve: "omit",
  epicLength: "omit",
  epicNeckline: "omit",
};

export default singleCategoryAccessoryEpicFilterOptions;
export const { epicCategories, epicMaternity, epicEmbellishments, epicPrint, epicSleeve, epicLength, epicNeckline } =
  singleCategoryAccessoryEpicFilterOptions;
